import axios from 'axios';
import auth from '@ifeng-fe/ui_pc_auth';
import React, { useEffect, useState } from 'react';
import { getHostIndex } from '@src/mobile/request';

const isWeixin = () => {
    // 判断是否是微信
    const ua = navigator.userAgent.toLowerCase();

    return ua.match(/MicroMessenger/i) === 'micromessenger';
};
const isMobile = () => {
    const flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    return flag;
};

// 微信拉起授权案例
const getInfo = () => {
    const callback = encodeURIComponent(`https://id.ifeng.com/sso/v1/?redirect=${encodeURIComponent(window.location.href)}`);

    const linkurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bd3b38f9c278ab4&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;

    window.location.href = linkurl;
};

// 获取微信登录后的用户信息
const getData = async (code) => {
    // const offUrl = `http://test0.platform.ifengidc.com/platform/server/trackApi/getAccessToken?code=${code}&proid=weixinh5`;
    const offUrl = `https://user.iclient.ifeng.com/Api_User_Userbasic/weixinLogin?code=${code}&proid=weixinh5`;
    const res = await axios.get(offUrl);
    let { data } = res;
    let token = '';

    if (typeof data.data === 'object') {
        token = data.data.token;
        const user_info = data.data.user_info;
        const { realname_mobile } = user_info;

        window.localStorage.setItem('realname_mobile', realname_mobile);
    } else {
        data = JSON.parse(data.data);
        console.log(data);
        token = data.data.token;
    }

    console.log(token);
    window.localStorage.setItem('token', token);
    document.cookie = `sid=${token}; path=/; domain=.ifeng.com`;
    // setUserInfo({
    //   token: data.token,
    //   user_info: data.user_info,
    //
    // });
};
const login = async ({ pcLogin = false, loginId = '' }) => {
    let loginFlag = false;

    if (window.grounds) {
        // 未登录拉起登录
        if (!window.grounds.userIsLogin()) {
            // 没有登录的话
            window.grounds.userLogin();

            return;
        } else {
            loginFlag = true;
            document.cookie = `sid=${window.grounds.getUserInfo().getToken()}; path=/; domain=.ifeng.com`;
        }
    } else {
        const query = window.location.search;

        if (query.indexOf('code') > -1) {
            const url = window.location.href;
            const params = url.split('?')[1];
            const paramsArr = params.split('&');
            const paramsObj = {};

            paramsArr.forEach((item) => {
                const itemArr = item.split('=');

                paramsObj[itemArr[0]] = itemArr[1];
            });
            // 发送code 到服务端
            await getData(paramsObj['code']);
            loginFlag = true;
        } else if (!window.localStorage.getItem('token')) {
            if (isMobile()) {
                getInfo();
            } else if (pcLogin) {
                // pc登录
                if (!auth.isLogin()) {
                    auth.login(loginId);
                } else {
                    const userInfo = auth.getUserInfo() || {};

                    window.localStorage.setItem('token', userInfo.sid);
                    loginFlag = true;
                }
            }
        } else {
            loginFlag = true;
        }
    }

    return loginFlag;
};

const useCategory = (name) => {
    const [voteCategory, setVoteCategory] = useState('');
    const getAllResult = async (name) => {
        const { voteItem = [] } = (await getHostIndex()) || {};

        const temp = voteItem.find((item) => item.id === name);

        setVoteCategory(temp?.name);
    };

    useEffect(() => {
        if (name) {
            getAllResult(name);
        }
    }, [name]);

    return { voteCategory };
};

const handleSearch = () => {
    const ret = {};
    const seg = window.location.search.substring(1).split('&');
    const len = seg.length;
    let i = 0;
    let s = [];

    for (; i < len; i++) {
        if (!seg[i]) {
            continue;
        }
        s = seg[i].split('=');
        ret[s[0]] = s[1];
    }

    return ret;
};

const jumpPageUrl = () => {
    const liveUrl = location.href.split('?')?.[0] || '';
    const urlSplit = liveUrl.split('/') || [];

    urlSplit.pop();
    const hostUrl = urlSplit.join('/');

    return hostUrl;
};

export { isWeixin, isMobile, login, useCategory, handleSearch, jumpPageUrl };
